const state = {
  nav: [{
    label: 'newGame',
    link: 'newGame',
    mediumUp: true,
    class: 'highlight'
  }, {
    label: 'newCard',
    link: 'newCard'
  }, {
    label: 'myCards',
    link: 'myCards',
    auth: true
  }, {
    label: 'myProfile',
    link: 'myProfile',
    auth: true
  }, {
    label: 'myGroups',
    link: 'myGroups',
    auth: true
  }, {
    label: 'login',
    link: 'login',
    auth: false,
    class: 'login'
  }, {
    label: 'logout',
    link: 'logout',
    auth: true,
    class: 'logout'
  }]
}

const getters = {
  getNav (state) {
    return state.nav
  }
}

export default {
  state,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/nav.js